<script>
import { Bar } from "vue-chartjs"

export default {
    extends: Bar,
    props: ["dataBar"],

    mounted() {
        // console.log(this.dataBar, "-- dataBar")
        this.renderChart(
            // {
            //     labels: [
            //         "Chingchai",
            //         "Akkapong",
            //         "Lungpon",
            //         "lungtuu",
            //         "AAAA",
            //         "BBBB",
            //         "CCCC",
            //     ],
            //     datasets: [
            //         {
            //             label: "Open",
            //             backgroundColor: "#f87979",
            //             data: [99, 20, 12, 39, 88, 77, 66],
            //         },
            //         {
            //             label: "KCI",
            //             backgroundColor: "#667435",
            //             data: [12, 43, 55, 1, 22, 33, 44],
            //         },
            //         {
            //             label: "Close",
            //             backgroundColor: "#124435",
            //             data: [11, 22, 33, 44, 55, 11, 22],
            //         },
            //     ],
            // },
            this.dataBar,
            { responsive: true, maintainAspectRatio: false }
        )
    },
}
</script>
